import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CourseEditorLayout } from "@/modules/learningCenter/features/CourseManagement/components/CourseEditorLayout/CourseEditorLayout";
import { useEditCourse } from "@/modules/learningCenter/features/CourseManagement/hooks/useEditCourse/useEditCourse";

const EditCourse: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const {
    form,
    metadata,
    course,
    loading,
    error,
    isSubmitting,
    submitForm,
    handlePublish,
    handleArchive,
  } = useEditCourse(uuid ?? "");

  const handlePreview = () => {
    if (uuid) {
      navigate(`/hub/learning-center/courses/${uuid}`);
    }
  };

  return (
    <CourseEditorLayout
      course={course}
      error={error}
      form={form}
      isSubmitting={isSubmitting}
      loading={loading}
      metadata={metadata}
      onArchive={handleArchive}
      onPreview={handlePreview}
      onPublish={handlePublish}
      onSubmit={submitForm}
    />
  );
};

export default EditCourse;
